import React from 'react';
const captions = [
  'Lateral Completo',
  'Tres cuartos frente conductor',
  'Tres cuartos trasero acompañante',
  'Interior frente completo',
  'Interior frente tablero instrumentos',
];

const GalleryVehicle = () => {
  return (
    <div className="tcc-card-gallery mt-3">
      {captions.map((caption, index) => (
        <div key={caption} className="tcc-card-gallery-containter">
          <img
            className="tcc-card-gallery-containter-img"
            src={`${process.env.PUBLIC_URL}/media/tcc/cer-${index}.png`}
            alt={caption}
          />
          <div className="tcc-card-gallery-containter-caption">{caption}</div>
        </div>
      ))}
    </div>
  );
};

export default GalleryVehicle;
